export const API_ENDPOINT = 'http://localhost:8000';
// export const API_ENDPOINT = 'https://9c35-2601-647-5400-260-6445-506b-4f4b-f13d.ngrok.io';
export const GOOGLE_CLIENT_ID = '1020175780794-o8perjgbl8n5kdn99vlblo8gse8nbuvi.apps.googleusercontent.com';
export const CAPTHCA_SITE_KEY = "6LcBX74jAAAAAN-cLPyyl4u29NVdIt5FR2UPu1-h";